import { FloatingList, UseFloatingReturn } from '@floating-ui/react'
import clsx from 'clsx'
import React from 'react'
import { TSizeAll } from 'src/types'
import styles from './SelectDropdown.module.scss'

export const SelectDropdown = ({
  floatingStyles,
  children,
  floatingProps,
  elementsRef,
  labelsRef,
  size,
  isOpen,
  refs,
}: {
  children: JSX.Element[]
  floatingStyles?: React.CSSProperties
  floatingProps: Record<string, unknown>
  elementsRef: React.MutableRefObject<(HTMLElement | null)[]>
  labelsRef: React.MutableRefObject<(string | null)[]>
  size: TSizeAll
  isOpen: boolean
  refs: UseFloatingReturn['refs']
}) => {
  return (
    <div
      ref={refs.setFloating}
      style={floatingStyles}
      {...floatingProps}
      className={clsx(
        'mui-select-dropdown',
        'drop-shadow-large-down-10',
        styles.dropdown,
        styles[size],
        {
          [styles.closed]: !isOpen,
        },
      )}
    >
      <ul className={clsx('mui-select-dropdown-list', styles.list)}>
        <FloatingList elementsRef={elementsRef} labelsRef={labelsRef}>
          {children}
        </FloatingList>
      </ul>
    </div>
  )
}
